function zero_fill(val) {
    if (val < 10) {
        val = `0${val}`;
    }
    return val;
}

function daysBetween(date1, date2) {
    const msInDay = 24 * 60 * 60 * 1000;
    const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return Math.floor((utc2 - utc1) / msInDay);
}

YP.EventManager = function () {
    const eventForm = $('form.create-event');
    const eventCloneLink = $('.event-clone-link');
    const eventTitleInput = $('.inline-input.event-title');
    const participantWidgetButton = $('.js-event-widget-face');
    const eventsTable = $('.event-list');

    if (eventForm.length > 0) {
        const restrictToInvite = $('.js-event-form #event_EventSetting_restrict_to_invite');
        const canInvite = $('.js-event-form #event_EventSetting_participant_can_invite');
        var password = $('.js-event-form #event_EventSetting_password');
        var liChoosers = $('.event-form-orgas-choose li, .event-form-orgas-choose li select');
        var privacyInput = $('.container__select_privacy');
        var showPassword = $('.js-event-form .js-symbol-password');

        var pictureModule = $('.js-event-form #event_EventSetting_picture_module');
        var end_date = $('.field-inline.end_date');
        var end_date_calc = $('.end_date_calc');
        var begin_date = $('#event_begin_date');
        var begin_time = $('#event_begin_time');
        var showOptions = $('.show-options');
    }
    return {
        init() {
            $('.toDoLink').live('click', this.displayToDo);
            YP.EventManager().initStatsPopover();

            if (eventsTable.length > 0) {
                YP.EventManager().initEventsList();
            }
            if (eventCloneLink.length > 0) {
                YP.ModalManager().setPreCallSuccess(this.initEventCloneForm);
            }

            YP.EventManager().initMenu();

            if (eventForm.length > 0) {
                eventTitleInput.live('keyup', this.resizeInput);
                eventTitleInput.each(this.resizeInput);
                liChoosers.live('click', this.selectAsso);
                showOptions.live('click', this.showOptions);

                privacyInput.live('change', this.changePrivacy).change();
                showPassword.live('click', this.doShowPassword);
                pictureModule.live('change', this.changePictureModule);
                $('span.add-end-date').live('click', this.addEndDate);
                begin_time.change(() => {
                    begin_date.change();
                });
                begin_date.change(() => {
                    date = begin_date.val();
                    time = begin_time.val();
                    d = date.split('/');
                    t = time.split(':');
                    est = new Date(d[2], d[1], d[0], t[0], t[1]);
                    est.setMinutes(est.getMinutes() + (9 * 60));
                    est.setMonth(est.getMonth() - 1);
                    end_date_calc.html(`Date de fin prévue le : ${$.datepicker.formatDate('dd/mm/yy', est)} ${zero_fill(est.getHours())}:${zero_fill(est.getMinutes())}`);
                }).change();

                function format(state) {
                    return state.text;
                }
                $('.js-event-form #event_host_id').select2({
                    placeholder: 'Selectionner une salle',
                    width: '400px',
                    formatResult: format,
                    formatSelection: format,
                    allowClear: true,
                });
                $('.js-event-form #event_host_id').on('change', (e) => {
                    $('#event_place').val($('.form_guest_address').text()).trigger('geocode');
                    if (!$('.place_location_name').val().length) {
                        $('.place_location_name').val($('.form_guest_name').text());
                    }
                    if (e.removed) {
                        $('.place-search-input').show();
                        $('.place-details').hide();
                        $('#event_place').val('').focus();
                        $('.place_location_addr').val('');
                        $('.place_location_lat').val('');
                        $('.place_location_lng').val('');
                        $('.place_location_name').val('');
                        $('.place_location_city').val('');
                        $('.place_location_country').val('');
                        $('.place_location_postcode').val('');
                        $('.place-details .preview_place_nomap').hide();
                    }
                });

                $('#event_begin_date').on('change', function (e) {
                    const end = $('#event_end_date');

                    const beginVal = moment($(this).val(), 'DD-MM-YYYY');
                    const endVal = moment(end.val(), 'DD-MM-YYYY');

                    if (beginVal.unix() > endVal.unix()) {
                        end.val($(this).val());
                    }
                });

                if (password.closest('.c-form__line').hasClass('c-form__line_error')) {
                    $('.js-event-form .line_password').show();
                }
            }
        },
        resizeInput() {
            $(this).attr('size', $(this).val().length);
        },
        selectAsso(e) {
            const el = $(this);
            const select = (el.is('select')) ? el : $('select', el);
            e.preventDefault();
            chooseLi(el);
            if (el.data('orga')) {
                if (select.length == 0) { // pas d'association
                    jQuery.facebox({
                        ajax: el.data('url-orga'),
                        opacity: 0.5,
                        loadingImage: '/images/dots.gif',
                        closeImage: '/images/facebox/closelabel.png',
                    });
                }
            } else {
                $('option:first', eventAssoSelect).attr('selected', 'selected');
                eventAssoSelect.change();
                $('#event_asso_id_hidden').val('0');
            }
            chooseLi(el);
            if (el.data('orga')) {
                imgChooser.addClass('orga');
            } else {
                imgChooser.removeClass('orga');
            }
        },
        chooseLi(el) {
            liChoosers.removeClass('active');
            el.addClass('active');
            imgChooser.addClass('orga');
        },
        changePrivacy() {
            // On change select
            $('.js-event-form .line_password').hide();
            $('.js-event-form .line_restrict_to_group').hide();
            $('.container__select_privacy').parent().find('.container__info').text($('.container__select_privacy select option:selected').data('help'));

            if ($('.container__select_privacy select').val() == 'public') {
                // 0 - Public
                $('.js-event-form .line_password input').val('');
            } else if ($('.container__select_privacy select').val() == 'invitation') {
                // 2 - Invitation
                $('.js-event-form .line_password input').val('');
                $('.js-event-form .line_restrict_to_group').show();
            } else {
                // 3 - Mot de passe
                $('.js-event-form .line_password').show();
                const blockPassword = $('.js-event-form .js-input_password');
                blockPassword.prop('type', 'password');
            }
        },
        doShowPassword(e) {
            e.preventDefault();
            const blockPassword = $('.js-event-form .js-input_password');

            if ($(this).hasClass('is-visible')) {
                $(this).removeClass('is-visible');
                blockPassword.prop('type', 'password');
            } else {
                $(this).addClass('is-visible');
                blockPassword.prop('type', 'text');
            }
            const value = blockPassword.val();
            blockPassword.focus().val('').val(value);
        },
        changePictureModule() {
            $next = $(this).parent('div').next('div');
            $next.toggle();
        },
        addEndDate(e) {
            $('input.timepicker', end_date).removeAttr('disabled');
            $('input.input-calendar', end_date).removeAttr('disabled').datepicker({
                dateFormat: 'dd/mm/yy',
                constrainInput: false,
                minDate: 0,
                nextText: '&gt;',
                prevText: '&lt;',
            }).val(begin_date.val());
            end_date.show();
            $(this).hide();
            end_date_calc.hide();
            e.preventDefault();
        },
        showOptions(e) {
            e.preventDefault();
            $('.event-settings').show();
            showOptions.parent().hide();
        },
        initEventCloneForm() {
            initDatePicker();

            $(document).on('change', '.clone-begin', function (e) {
                const dataId = $(this).data('id');

                const endSelector = $(`.clone-end[data-id=${dataId}]`);

                const beginVal = moment($(this).val(), 'DD-MM-YYYY');
                const endVal = moment(endSelector.val(), 'DD-MM-YYYY');

                if (beginVal.unix() > endVal.unix()) {
                    endSelector.val($(this).val());
                }
            });

            const MAX_EVENT_DURATION = 367;

            function parseDateFr(dateStr) {
                if (!dateStr) return null;
                const parts = dateStr.split('/');
                if (parts.length !== 3) return null;
                return new Date(parts[2], parts[1] - 1, parts[0]);
            }

            function validateCloneDuration() {
                const form = $('#event-clone-form');
                const submitBtn = form.find('button[type="submit"]');
                let hasError = false;

                $('#clone-duration-alert').remove();

                form.find('[name*="[begin][date]"]').each(function () {
                    const beginVal = $(this).val();
                    const endInput = $(this).closest('.c-grid__row').find('[name*="[end][date]"]');
                    const endVal = endInput.val();

                    if (beginVal && endVal) {
                        const beginDate = parseDateFr(beginVal);
                        const endDate = parseDateFr(endVal);

                        if (beginDate && endDate) {
                            const duration = daysBetween(beginDate, endDate);

                            if (duration >= MAX_EVENT_DURATION) {
                                hasError = true;
                                endInput.closest('.c-form-item').addClass('c-form-item--error');
                            } else {
                                endInput.closest('.c-form-item').removeClass('c-form-item--error');
                            }
                        }
                    }
                });

                if (hasError) {
                    const alertHtml = `
                        <div id="clone-duration-alert" class="c-msg-box c-msg-box--error mt-3">
                            <div class="c-msg-box__text">
                                <i class="yp_font yp_font_warning"></i>
                                La durée de l'événement ne peut pas excéder ${MAX_EVENT_DURATION} jours.
                            </div>
                        </div>
                    `;
                    form.find('#date-list').after(alertHtml);
                    submitBtn.prop('disabled', true).addClass('c-btn--disabled');
                } else {
                    const hasOtherErrors = form.find('.c-form-item--error').length > 0;

                    if (!hasOtherErrors) {
                        submitBtn.prop('disabled', false).removeClass('c-btn--disabled');
                    }
                }
            }

            $(document).on('change changeDate', '#event-clone-form .input-calendar', validateCloneDuration);

            $('#event-clone-form .add-time').die().live('click', function (e) {
                index = $(this).data('index') + 1;
                url = $(this).data('url');
                if (index < 21) {
                    $.ajax({
                        type: 'GET',
                        url,
                        data: {
                            index,
                        },
                        success(data) {
                            $('#event-clone-form #date-list').append(data);
                            YP.ModalManager().positionModal();
                            if (index == 20) {
                                $('#event-clone-form .add-time').remove();
                            } else {
                                $('#event-clone-form .add-time').data('index', index);
                            }
                            initDatePicker();
                        },
                    });
                }
            });
        },
        initEventsList() {
            $('.event-list .event-item').mouseenter(function () {
                $('.event-index-info ').children('.event-item-info').hide();
                $('.event-list').children().removeClass('actif');
                $(this).addClass('actif');
                $(`.event-index-info  #event-${$(this).data('id')}`).show();
            });
        },
        initMenu(e) {
            if ($('#dropdownevent').length) {
                $(document).mouseup((e) => {
                    const container = $('#dropdownevent');
                    if (
                        !container.is(e.target) && container.has(e.target).length === 0 && container.hasClass('in')
                    ) {
                        container.collapse('hide');
                    }
                });
            }
        },
        displayToDo(e) {
            e.preventDefault();
            if ($('#to-do-panel').html().length == 0) {
                $('.toDoLink').addClass('active');
                $.ajax({
                    type: 'GET',
                    url: $(this).attr('href'),
                    success(data) {
                        $('#to-do-panel').html(data);
                        $('#to-do-panel').toggleClass('cbp-spmenu-open');
                        $('.toDoLink').html('Fermer');
                        $('.toDoLink').removeClass('active');
                    },
                    error(xhr, status, error) {
                        const err = eval(`(${xhr.responseText})`);
                    },
                });
            } else {
                if ($('.toDoLink').html() == 'Fermer') {
                    $('.toDoLink').html('Aide');
                } else {
                    $('.toDoLink').html('Fermer');
                }
                $('#to-do-panel').toggleClass('cbp-spmenu-open');
            }
        },
        initStatsPopover(e) {
            $('.stat-pop .statpopover').popover({
                html: true,
            });
            $('.stat-pop .statpopover').live('click', function (e) {
                $(this).parent().parent().toggleClass('active');
            });
            $(document).live('click', (e) => {
                $('.stat-pop .statpopover').popover('hide');
                $('.stat').removeClass('active');
            });
            $('.stat-pop .statpopover').live('click', (e) => {
                e.stopPropagation();
            });
            $('.popover').live('click', (e) => {
                e.stopPropagation();
            });
        },
    };
};
window.addEventListener('load', () => {
    YP.EventManager().init();
});
